import { createAction, props } from '@ngrx/store';
import { SnackBarData } from '@ra-state';

export const displayMessage = createAction('[SNACKBAR] Send Message', props<{ payload: SnackBarData }>());
